export default __webpack_public_path__ + "static/media/ministry_upload_template.127a4bb0.csv";